import {
  IonItem,
  IonIcon,
  IonLabel,
  IonList,
  IonItemGroup,
  IonItemDivider,
  IonNote,
} from "@ionic/react";

import { calculatorOutline, personOutline, powerOutline, shirtOutline } from "ionicons/icons";
import { useFirebase } from "../components/firebase-provider";
import PageLayout from "../components/layout";
const OtherMenuList: React.FC = () => {
  const {auth} = useFirebase();
  return (
    <>
      <PageLayout title="Menu Lainnya">
        <IonList>
          <IonItemGroup>
              <IonItemDivider>
                  <IonLabel>Produk dan Biaya</IonLabel>
              </IonItemDivider>
            <IonItem button routerLink='/app/product'>
              <IonIcon icon={shirtOutline} slot="start" />
              <IonLabel>Atur Produk</IonLabel>
            </IonItem>
            <IonItem button routerLink='/app/cost'>
              <IonIcon icon={calculatorOutline} slot="start" />
              <IonLabel>Hitung Biaya Sablon</IonLabel>
            </IonItem>
          </IonItemGroup>
          <IonItemGroup>
              <IonItemDivider>
                  <IonLabel>Akun</IonLabel>
              </IonItemDivider>
            <IonItem button routerLink='/app/profile'>
              <IonIcon icon={personOutline} slot="start" />
              <IonLabel>Profil</IonLabel>
            </IonItem>
            <IonItem button onClick={()=>auth.signOut()} >
              <IonIcon icon={powerOutline} slot="start" />
              <IonLabel>Keluar</IonLabel>
            </IonItem>
          </IonItemGroup>
          <IonItemGroup>
              <IonItemDivider>
                  <IonLabel>Tentang Aplikasi</IonLabel>
              </IonItemDivider>
            <IonItem>
              <IonLabel>Versi</IonLabel>
              <IonNote slot="end">2.0.1</IonNote>
            </IonItem>
            <IonItem button routerLink='/credit'>
              <IonLabel>Kredit dan Atribut</IonLabel>
            </IonItem>
          </IonItemGroup>
        </IonList>
      </PageLayout>
    </>
  );
};

export default OtherMenuList;
